<template>
  <v-container>
    <v-row no-gutters>
      <v-col>
        <v-row v-if="addSignerVisible" no-gutters>
          <v-col>
            <signer-form />
          </v-col>
        </v-row>
        <v-row v-else no-gutters>
          <v-col>
            <v-row no-gutters>
              <v-col xs="3" md="3">
                <v-btn
                    color="teal accent-4"
                    id="add_signers__nuevo_firmante__button"
                    @click="showAddSigner"
                    outlined
                    class="mt-5"
                    elevation="1"
                >
                  <v-icon small left>{{ icon.plus }}</v-icon>
                  Nuevo Firmante</v-btn
                >
              </v-col>
              <v-spacer />
              <v-col>
                <v-switch
                    v-model="userSignerCheck"
                    id="add_signers__voy_firmar_documento__switch"
                    inset
                    color="teal accent-4"
                    hide-details
                    label="Voy a firmar el documento"
                    @click.stop="stopEvent"
                ></v-switch>
                <v-switch
                    v-model="firmarEnOrdenCheck"
                    id="add_signers__respetar_orden_firmante__switch"
                    inset
                    color="teal accent-4"
                    label="Respetar el orden de los firmantes"
                    hide-details
                ></v-switch>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <signers-table class="mt-8"/>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mdiPlus } from '@mdi/js'
import SignerForm from '@/modules/signers/components/SignerForm'
import SignersTable from '@/modules/signers/components/SignersTable'
import {
  signersStoreData,
  signersStoreActions
} from '@/modules/signers/store/signersStoreHelpers'
import { pushNotification } from '@/store/helpers'

export default {
  name: 'AddSigners',
  components: {
    SignersTable,
    SignerForm
  },
  data() {
    return {
      icon: {
        plus: mdiPlus
      }
    }
  },
  computed: {
    ...signersStoreData,
    userSignerCheck: {
      get() {
        return this.isUserSigner
      }
    },
    firmarEnOrdenCheck: {
      get() {
        return this.firmarEnOrden
      },
      set(value) {
        this.setFirmarEnOrden(value)
      }
    }
  },
  methods: {
    ...signersStoreActions,
    stopEvent(e){
      e.preventDefault()
      e.stopPropagation()
      
      let nexVal = !this.userSignerCheck
      this.setUserSigner(!this.userSignerCheck)
      
      if(nexVal && nexVal != this.userSignerCheck){
        pushNotification(
          this.$store,
          'Ya existe un firmate con el mismo correo o rfc',
          'error',
          'left',
          false,
          true
        )
      }
    }
  }
}
</script>
